import React from "react";
import DevTools from "utils/dev-tools";

interface Props {
  children: ((isDevelopment: boolean) => React.ReactNode) | React.ReactNode;
}

const Development: React.FC<Props> = (props) => {
  const isDevelopment = DevTools.debug;

  if (typeof props.children === "function") {
    return (props.children as CallableFunction)(isDevelopment);
  }

  if (isDevelopment) {
    return <>{props.children}</>;
  }

  return null;
};

export default Development;
